import {createSelector} from 'reselect'
import {ICalTabType} from './constants'
import {getLeaveTypes, getTimeZoneGroups, getUserGroupsWithDefault, getUsers} from '../../../js/entities/selectors'
import {convertData, sortFeedsBySetting} from './utils'

const getICalendarFeedsState = state => state.iCalendar.feeds

export const getActiveTab = createSelector(
    getICalendarFeedsState,
    state => state.activeTab
)

export const getRecentlyConfiguredFeedId = createSelector(
    getICalendarFeedsState,
    state => state.recentlyConfiguredFeedId
)

export const getAllFeedsSorting = createSelector(
    getICalendarFeedsState,
    state => state.allSorting
)

export const getSharedFeedsSorting = createSelector(
    getICalendarFeedsState,
    state => state.sharedSorting
)

export const getAllFeedsMap = createSelector(
    getICalendarFeedsState,
    state => state.allFeeds
)

export const getAllFeedsForTable = createSelector(
    getAllFeedsMap,
    getUsers,
    getLeaveTypes,
    getUserGroupsWithDefault,
    getTimeZoneGroups,
    getRecentlyConfiguredFeedId,
    getAllFeedsSorting,
    (feeds, users, lt, ug, tz, recentlyConfiguredId, sorting) => sortFeedsBySetting(
        convertData(feeds, lt, users, ug, tz, recentlyConfiguredId),
        sorting
    )
)

export const getSharedFeedsMap = createSelector(
    getICalendarFeedsState,
    state => state.sharedFeeds
)

export const getSharedFeedsForTable = createSelector(
    getSharedFeedsMap,
    getUsers,
    getLeaveTypes,
    getUserGroupsWithDefault,
    getTimeZoneGroups,
    getSharedFeedsSorting,
    (feeds, users, lt, ug, tz, sorting) => sortFeedsBySetting(convertData(feeds, lt, users, ug, tz), sorting)
)

export const isFeedsEmpty = createSelector(
    getICalendarFeedsState,
    state => state.activeTab === ICalTabType.ALL_FEEDS && (!state.allFeeds || window.isObjectEmpty(state.allFeeds))
             || state.activeTab === ICalTabType.USER_FEEDS && (!state.sharedFeeds || window.isObjectEmpty(state.sharedFeeds))
)

export const isLoading = createSelector(
    getICalendarFeedsState,
    state => state.loading
)

export const isTopButtonsShown = createSelector(
    isLoading, getActiveTab, getAllFeedsMap,
    (loading, activeTab, allFeeds) => !loading && activeTab === ICalTabType.ALL_FEEDS && !!allFeeds && !window.isObjectEmpty(allFeeds)
)

export const getICalInfo = createSelector(
    getICalendarFeedsState,
    state => ({
        activeTab: state.activeTab,
        allSorting: state.allSorting,
        sharedSorting: state.sharedSorting,
    })
)

export const isUserActionLoading = state => getICalendarFeedsState(state).userActionLoading

export const isFeedsContentLoading = state => getICalendarFeedsState(state).feedsContentLoading


// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/selectors.js